import { useState } from 'react';

import { useTranslation } from 'react-i18next';

export const useChecklistItemErrorHandle = () => {
    const { t } = useTranslation();
    const [triggerAnimationError, setTriggerAnimationError] = useState(false);
    const [errorValidation, setErrorValidation] = useState({ isError: false, errorMessage: '' });

    const clearError = () => {
        setErrorValidation({ isError: false, errorMessage: '' });
    };
    const addError = (errorText: string = t('Checklist.Item.InputPlaceholder')) => {
        setErrorValidation({
            isError: true,
            errorMessage: errorText,
        });
        setTriggerAnimationError(true);
    };

    return {
        errorValidation,
        triggerAnimationError,
        clearError,
        addError,
        setTriggerAnimationError,
    };
};
